module.exports = __webpack_public_path__ + "img/Pot2.fffea7e6.svg";